import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from 'chart.js';
import _ from 'lodash';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const wrapLabel = (text, wordsPerLine = 1) => {
  if (!text) return '';
  const words = text.split(' ');
  const lines = [];

  for (let i = 0; i < words.length; i += wordsPerLine) {
    lines.push(words.slice(i, i + wordsPerLine).join(' '));
  }

  return lines;
};

const ClusterBarChart = ({ data = [] }) => {
  if (!data.length) return <p>No data available</p>;

  const isMobile = window.innerWidth < 600;

  const labels = _.map(data, item => _.capitalize(item?.category_name));
  const wrappedLabels = labels.map(label => wrapLabel(label));

  const studentMarks = _.map(data, item => Number(_.get(item, 'student_marks', 0)));
  const allMarksList = _.map(data, item => _.get(item, 'all_marks', []));
  const percentiles = _.map(data, item => _.get(item, 'cat_percentile', 0));

  // Get min and max for each mark list
  const minMarks = allMarksList.map(marks => {
    const numeric = marks.filter(m => m !== null && m !== undefined).map(Number);
    return _.min(numeric) || 0;
  });
  
  const maxMarks = allMarksList.map(marks => {
    const numeric = marks.filter(m => m !== null && m !== undefined).map(Number);
    return _.max(numeric) || 0;
  });
  
  // Calculate percentiles
  // const percentiles = allMarksList.map((marks, idx) => {
  //   const score = studentMarks[idx];
  //   const numeric = marks.filter(m => m !== null && m !== undefined).map(Number).sort((a, b) => a - b);
  
  //   const below = numeric.filter(m => m < score).length;
  //   const equal = numeric.filter(m => m == score).length;
  
  //   return numeric.length > 0
  //     ? _.round(((below + 0.5 * equal) / numeric.length) * 100, 1)
  //     : 0;
  // });
  

  const getLabelPlugin = (labels, studentMarks, percentiles, minMarks, maxMarks, isMobile) => ({
    id: 'customYAxisLabels',
    afterDraw: (chart) => {
      const {
        ctx,
        scales: { x, y },
      } = chart;
  
      labels.forEach((label, i) => {
        const yPos = y.getPixelForValue(i);
        const studentScore = studentMarks[i];
        const percentile = percentiles[i];
        const min = minMarks[i];
        const max = maxMarks[i];
        const xPos = 110;
  
        ctx.save();
        ctx.font = isMobile ? '8px Montserrat' : '12px Montserrat';
        ctx.fillStyle = '#333';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
  
        const info = `📈 ${percentile}%ile | 🎯 ${studentScore}% | 🔻 ${min}% | 🟢 ${max}%`;
        ctx.fillText(info, xPos, yPos);
        ctx.restore();
      });
    },
  });
  

  const chartData = {
    labels: wrappedLabels,
    datasets: [
      {
        label: 'Percentile',
        data: percentiles,
        backgroundColor: '#9834F076',
        borderRadius: 6,
        barThickness: isMobile ? 16 : 26,
      },
    ],
  };


  const labelPlugin = {
    id: 'customYAxisLabels',
    afterDraw: (chart) => {
      const {
        ctx,
        chartArea: { top },
        scales: { x, y },
      } = chart;

      labels.forEach((label, i) => {
        const yPos = y.getPixelForValue(i);
        const studentScore = studentMarks[i];
        const percentile = percentiles[i];
        const min = minMarks[i];
        const max = maxMarks[i];
        const xPos = 110;

        ctx.save();
        ctx.font = isMobile ? '8px Montserrat' : '12px Montserrat';
        ctx.fillStyle = '#333';
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';

        const info = `📈 ${percentile}%ile | 🎯 ${studentScore}% | 🔻 ${min}% | 🟢 ${max}%`;
        ctx.fillText(info, xPos, yPos);
        ctx.restore();
      });

    },
  };

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      tooltip: {
        callbacks: {
          label: (ctx) => {
            const i = ctx.dataIndex;
            return [
              `Percentile: ${percentiles[i]}%ile`,
              `Your Marks: ${studentMarks[i]}%`,
              `Min: ${minMarks[i]}%`,
              `Max: ${maxMarks[i]}%`,
            ];
          },
        },
      },
      legend: { display: false },
    },
    scales: {
      x: {
        beginAtZero: true,
        max: 100,
        ticks: {
          font: { family: 'Montserrat', size: isMobile ? 10 : 12 },
        },
        title: {
          display: true,
          text: 'Percentile',
          font: { family: 'Montserrat', size: 14 },
        },
        grid: { display: false },
      },
      y: {
        ticks: {
          font: { weight:'bold' ,family: 'Montserrat', size: isMobile ? 9 : 11 },
          callback: function (val, index) {
            const label = wrappedLabels[index];
            return label;
          },
        },
        grid: { display: false },
      },
    },
  };

  return (
    <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', width: '100%' }}>
    <div
      style={{
        width: isMobile ? 'max-content' : '100%',
          height: `${data.length * 80}px`,
        }}
      >
      <Bar
        key={JSON.stringify(data)}
        data={chartData}
        options={options}
        plugins={[
          getLabelPlugin(labels, studentMarks, percentiles, minMarks, maxMarks, isMobile),
        ]}
      />
    </div>
  </div>
  );
};

export default ClusterBarChart;
